import CamplaCoreService from "../services/CamplaCoreService";

class PluginHelper {
  static async lookupUser(student){
    const userArr = await CamplaCoreService.lookupUser(student.email);
    if (userArr.length > 0){
      const user = Object.assign({}, userArr[0]);
      user["name"] = `${student.firstname} ${student.lastname}`;
      return {
        valid: true,
        email: student.email,
        user: user
      }
    }else{
      return {
        valid: false,
        email: student.email,
        user: null
      }
    }
  }

  static async validateStudentsEmails(students) {
    const promises = [];
    students.forEach(student => promises.push(PluginHelper.lookupUser(student)));
    const validatedStudents = await Promise.all(promises);
    const invalidStudents = validatedStudents.filter(is => !is.valid);
    if (invalidStudents.length > 0){
      throw new Error(`Invalid users found: ${invalidStudents.map(is => is.email).join(", ")}`);
    }
    return validatedStudents.map(vs => vs.user);
  }

  static async calculateAndCreateClasses(validatedData, userId, errorHandling){
    const maximumClassSize = 500;

    const createdClasses = [];
    const createdModuleClasses = [];

    if (validatedData.members.length <= maximumClassSize){
      const response = await PluginHelper.createClassAndModuleClass(validatedData, userId);
      if (response){
        createdClasses.push(response.createdClass);
        createdModuleClasses.push(response.createdModuleClass);
      }else{
        errorHandling();
        return null;
      }
    }else{
      const members = [...validatedData.members];
      const groupCount = Math.ceil(members.length / maximumClassSize);
      let elementsLeft = members.length;
      for (let i = 0; i < groupCount; i++){
        const end = elementsLeft > maximumClassSize ? (maximumClassSize * (i + 1)) : members.length;
        const subMembers = members.slice((maximumClassSize * i), end);

        const validatedDataClone = Object.assign({}, validatedData);
        validatedDataClone["members"] = subMembers;
        validatedDataClone["name"] = `${validatedDataClone["name"]}-${(i + 1)}`;


        const response = await PluginHelper.createClassAndModuleClass(validatedDataClone, userId);
        if (response){
          createdClasses.push(response.createdClass);
          createdModuleClasses.push(response.createdModuleClass);
        }else{
          errorHandling();
          return null;
        }

        elementsLeft = elementsLeft - maximumClassSize;
      }
    }
    return {createdClasses, createdModuleClasses}
  }

  static async createClassAndModuleClass(validatedData, userId){
    let createdClass = null;
    let createdModuleClass = null;
    try {
      createdClass = await CamplaCoreService.createClass({
        name: validatedData.name,
        members: validatedData.members,
        userId: userId
      });
      createdModuleClass = await CamplaCoreService.createModuleClass({
        userId: userId,
        classId: createdClass._id,
        moduleId: validatedData.moduleId,
        year: validatedData.year,
        isFall: validatedData.isFall
      });
      return {createdClass, createdModuleClass}
    }catch (err){
      if (createdClass) {
        try {
          await CamplaCoreService.deleteClass(createdClass._id);
        } catch (err) {}
      }
    }
    return null;
  }
}

export default PluginHelper;
